import { useEffect, useState } from "react";
import axios from "axios";
import { Copy, Check, X } from "lucide-react";
import { scrollToId } from "./SmoothScroll";

const KEY = "verbulat-banner-dismissed";

export const PromoBanner = () => {
  const [banner, setBanner] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const base = process.env.REACT_APP_BACKEND_URL;
    if (!base) return undefined;
    axios.get(`${base}/api/banner`)
      .then((r) => {
        const b = r.data?.banner;
        if (b?.code && sessionStorage.getItem(KEY) !== b.code) setBanner(b);
      })
      .catch(() => setBanner(null));
    return undefined;
  }, []);

  useEffect(() => {
    if (!copied) return undefined;
    const t = setTimeout(() => setCopied(false), 1600);
    return () => clearTimeout(t);
  }, [copied]);

  if (!banner) return null;
  const copy = async () => {
    try { await navigator.clipboard.writeText(banner.code); setCopied(true); } catch { setCopied(false); }
  };
  const ends = banner.expires_at ? ` · ends ${new Date(banner.expires_at * 1000).toLocaleDateString([], { month: "short", day: "numeric" })}` : "";

  return (
    <div className="relative flex min-h-9 items-center justify-center gap-2 bg-[var(--teal)] px-10 py-1.5 text-center text-xs font-medium text-[var(--ink)] sm:text-sm" data-testid="promo-banner">
      <button onClick={() => scrollToId("#pricing")} className="hover:underline" data-testid="promo-banner-link">
        Launch offer: <strong>{banner.off}</strong> your rewrite with code{ends}
      </button>
      <button onClick={copy} data-testid="promo-banner-copy"
        className="font-mono-d inline-flex items-center gap-1 rounded-md border border-[var(--ink)]/30 bg-[var(--ink)] px-2 py-0.5 tracking-widest text-[var(--teal)] transition-transform active:scale-95">
        {banner.code} {copied ? <Check className="h-3 w-3" /> : <Copy className="h-3 w-3" />}
      </button>
      <button onClick={() => { sessionStorage.setItem(KEY, banner.code); setBanner(null); }} aria-label="Dismiss" data-testid="promo-banner-dismiss"
        className="absolute right-3 top-1/2 -translate-y-1/2 opacity-70 hover:opacity-100">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
